import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    messages: [],
    isConnected: false,
    user: null,
    ws: null,
    clientId: null,
    token: null,
  },
  mutations: {
    SET_CONNECTION_STATUS(state, status) {
      state.isConnected = status
    },
    ADD_MESSAGE(state, message) {
      // 检查消息是否已经存在，避免重复添加
      const exists = state.messages.some(m => m.time === message.time && m.content === message.content && m.sender_id === message.sender_id);
      if (!exists) {
        state.messages.push(message)
      }
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_WEBSOCKET(state, ws) {
      state.ws = ws
    },
    SET_CLIENT_ID(state, clientId) {
      state.clientId = clientId
    },
    SET_TOKEN(state, token) {
      state.token = token
      // 保存到本地存储
      localStorage.setItem('token', token)
    },
    CLEAR_MESSAGES(state) {
      state.messages = []
    }
  },
  actions: {
    connectWebSocket({ commit, state }) {
      return new Promise((resolve, reject) => {
        try {
          // 从状态或本地存储获取token
          const token = state.token || localStorage.getItem('token')
          if (!token) {
            reject(new Error('未登录，无法连接聊天服务器'))
            return
          }

          // 在WebSocket URL中添加token参数
          const ws = new WebSocket(`wss://chat.xiaoesoft.top/api/ws?token=${token}`)
          
          ws.onopen = () => {
            commit('SET_CONNECTION_STATUS', true)
            commit('SET_WEBSOCKET', ws)
            resolve(ws)
          }
          
          ws.onclose = (event) => {
            commit('SET_CONNECTION_STATUS', false)
            commit('SET_WEBSOCKET', null)
            
            // 如果是因为聊天室已满而关闭
            if (event.code === 1008) {
              Vue.prototype.$message.error(event.reason || '聊天室人数已满')
              // 不要自动重连
              return
            }
            
            // 断线重连
            setTimeout(() => {
              this.dispatch('connectWebSocket')
            }, 3000)
          }
          
          ws.onerror = (error) => {
            console.error('WebSocket error:', error)
            reject(error)
          }
          
          ws.onmessage = (event) => {
            const message = JSON.parse(event.data)
            if (message.type === 'clientId') {
              commit('SET_CLIENT_ID', message.clientId)
            } else if (message.type === 'onlineCount') {
              // 在线人数更新由组件处理
              return
            } else {
              // 在添加到 store 前判断 isSelf
              const isSelfMessage = message.sender_id === state.clientId
              
              // 只添加非自己发送的消息广播
              if (!isSelfMessage) {
                // 确保消息对象有 isSelf 属性
                message.isSelf = false
                commit('ADD_MESSAGE', message)
              }
            }
          }
        } catch (error) {
          console.error('WebSocket connection error:', error)
          reject(error)
        }
      })
    },
    logout({ commit }) {
      commit('SET_CONNECTION_STATUS', false)
      if (this.state.ws) {
        this.state.ws.close()
      }
      commit('SET_WEBSOCKET', null)
      commit('SET_CLIENT_ID', null)
      commit('SET_TOKEN', null)
      commit('CLEAR_MESSAGES')
      localStorage.removeItem('token')
      localStorage.removeItem('isAuthenticated')
    }
  }
}) 